import GitHub from "../../components/GitHub";
import { order } from "../SmartSearchParammeter";

export default async function GitHubConfig(key) {
  return {
    description: "GitHub",
    id: "gitHub",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <GitHub searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["gitHub"] = value[0];
    }
  };
}
